import { useState } from "react";

import ShowCard from "../components/ShowCard";

import classes from "./css/Shows.module.css";

import SHOWS from "../data/SHOWS";

const YEARS = [2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018, 2017, 2016, 2015];

const ShowsPage = () => {
  const [selectedYear, setSelectedYear] = useState(2025);

  const changeYearHandler = (year) => {
    setSelectedYear(year);
  };

  return (
    <>
      <div className={classes.shows_header_main}>
        <div className={classes.shows_header}>
          <div>
            <span>Spett</span>
            <span>acoli</span>
          </div>
          <h1>
            dal 2015 <br /> ad oggi
          </h1>
        </div>
      </div>

      <div className={classes.year_list_main}>
        {YEARS.map((year) => (
          <button
            onClick={() => changeYearHandler(year)}
            className={`${classes.year_button} ${
              selectedYear === year && classes.active
            }`}
          >
            {year}
          </button>
        ))}
      </div>

      <div className={classes.grid}>
        <div className={classes.grid_row}>
          {SHOWS.map((show) =>
            show.year === selectedYear ? (
              <ShowCard
                id={show.id}
                date={show.date}
                title={show.title}
                author={show.author}
                description={show.description}
                wrap_text={show.wrap_text}
                image_main={show.image_main}
                image_one={show.image_one}
                image_two={show.image_two}
                image_three={show.image_three}
                image_four={show.image_four}
                image_five={show.image_five}
                image_six={show.image_six}
              />
            ) : null
          )}
        </div>
      </div>

      <div className={classes.thanks}>
        <p>
          Si ringraziano Silvio Ottaviano, Francesco Fiorello, Filippo Serra,
          Lorenzo Gigante e Pino Le Pera per aver documentato con le loro
          magnifiche foto gli spettacoli di questi ultimi anni
        </p>
      </div>
    </>
  );
};

export default ShowsPage;
